import { render } from "./museumIntangible.vue?vue&type=template&id=145dfc11"
import script from "./museumIntangible.vue?vue&type=script&lang=js"
export * from "./museumIntangible.vue?vue&type=script&lang=js"

import "./museumIntangible.vue?vue&type=style&index=0&id=145dfc11&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__